import styled from "styled-components";

// styles
import BodyText from "core/BodyText";
import { regular as regularFontWeight } from "core/fontStyles";

// styled-components
export const ParagraphStyled = styled(BodyText)`
    ${regularFontWeight}
`;
